var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3C1.11929 3 0 4.11929 0 5.5V8.5C0 9.94823 1.13755 10.8416 2.16839 11.0138C2.64016 11.0926 3 11.5062 3 12C3 12.4938 2.64016 12.9074 2.16839 12.9862C1.13755 13.1584 0 14.0518 0 15.5V18.5C0 19.8807 1.11928 21 2.5 21H21.5C22.8807 21 24 19.8807 24 18.5V15.5C24 14.0518 22.8625 13.1584 21.8316 12.9862C21.3598 12.9074 21 12.4938 21 12C21 11.5062 21.3598 11.0926 21.8316 11.0138C22.8625 10.8416 24 9.94823 24 8.5V5.5C24 4.11929 22.8807 3 21.5 3H2.5ZM2 5.5C2 5.22386 2.22386 5 2.5 5H14V19H2.5C2.22386 19 2 18.7761 2 18.5V15.5C2 15.2239 2.22554 15.0044 2.49791 14.9589C3.91779 14.7217 5 13.4872 5 12C5 10.5128 3.91779 9.2783 2.49791 9.04113C2.22554 8.99563 2 8.77614 2 8.5V5.5ZM16 19H21.5C21.7761 19 22 18.7761 22 18.5V15.5C22 15.2239 21.7745 15.0044 21.5021 14.9589C20.0822 14.7217 19 13.4872 19 12C19 10.5128 20.0822 9.2783 21.5021 9.04113C21.7745 8.99563 22 8.77614 22 8.5V5.5C22 5.22386 21.7761 5 21.5 5H16V19Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketX2);
export default __webpack_public_path__ + "static/media/TicketX2.b2092fdc2ff41055c91e0a8569f319a5.svg";
export { ForwardRef as ReactComponent };